// extracted by mini-css-extract-plugin
export default {"UploadSuccess":"UploadSuccess___uXjKM"};